function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.5 4C14.9477 4 14.5 4.44772 14.5 5C14.5 5.55228 14.9477 6 15.5 6V4ZM19.5 5H20.5C20.5 4.44772 20.0523 4 19.5 4V5ZM18.5 9C18.5 9.55228 18.9477 10 19.5 10C20.0523 10 20.5 9.55228 20.5 9H18.5ZM12.7929 10.2929C12.4024 10.6834 12.4024 11.3166 12.7929 11.7071C13.1834 12.0976 13.8166 12.0976 14.2071 11.7071L12.7929 10.2929ZM15.5 6H19.5V4H15.5V6ZM18.5 5V9H20.5V5H18.5ZM18.7929 4.29289L12.7929 10.2929L14.2071 11.7071L20.2071 5.70711L18.7929 4.29289Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.1875 6C12.7398 6 13.1875 5.55228 13.1875 5C13.1875 4.44772 12.7398 4 12.1875 4V6ZM20.5 12.3125C20.5 11.7602 20.0523 11.3125 19.5 11.3125C18.9477 11.3125 18.5 11.7602 18.5 12.3125H20.5ZM12.1875 4H7V6H12.1875V4ZM5.5 5.5V17.5H7.5V5.5H5.5ZM7 19H19V17H7V19ZM20.5 17.5V12.3125H18.5V17.5H20.5ZM19 19C19.8284 19 20.5 18.3284 20.5 17.5H18.5C18.5 17.2239 18.7239 17 19 17V19ZM5.5 17.5C5.5 18.3284 6.17157 19 7 19V17C7.27614 17 7.5 17.2239 7.5 17.5H5.5ZM7 4C6.17157 4 5.5 4.67157 5.5 5.5H7.5C7.5 5.77614 7.27614 6 7 6V4Z",
  fill: "white"
});

var SvgLink = function SvgLink(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLink, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/link.ff9664e2.svg";
export { ForwardRef as ReactComponent };